import { Image } from "antd";
import { Card, CardContainer } from "./CardProducts.styles";
import {
  findBundleByIdInBundles,
  getImageForBundle,
  sortBundles,
} from "../../tools/helpers";
import { COMBO } from "../../../ShopPage/constants";

const CardProducts = ({ bundles = [], onClick }) => {
  const sortedBundles = sortBundles(bundles);

  return (
    <>
      <CardContainer>
        {sortedBundles.map((bundle) => (
          <Card key={bundle._id}>
            <Image
              src={getImageForBundle(bundle)}
              alt={bundle.title}
              preview={false}
              onClick={() =>
                onClick(COMBO, findBundleByIdInBundles(bundle?._id, bundles))
              }
            />
          </Card>
        ))}
      </CardContainer>
    </>
  );
};

export default CardProducts;
